import { useGetMileageInfo } from '@/apis/rest/generated/hooks'

export const useMileageInfo = () => {
  const { data, isLoading, isError, error, refetch } = useGetMileageInfo({
    query: {
      refetchOnWindowFocus: false, // 화면 포커스 시 재요청 방지
      retry: 1, // 실패 시 1회만 재시도
    },
  })

  return {
    // API 응답 구조에 따라 실제 데이터만 쏙 빼서 반환합니다.
    // (보통 axios 응답은 data.data 안에 실제 값이 들어있습니다)
    mileageInfo: data,

    // 상태 및 액션
    isLoading,
    isError,
    error,
    refetch,
  }
}
